import React from 'react';

export interface CarpetaMasIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CarpetaMasIcon: React.FC<CarpetaMasIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.975 11.585v6.25M9.85 14.71h6.25m7.291 5.209a2.083 2.083 0 0 1-2.083 2.083H4.64a2.083 2.083 0 0 1-2.083-2.083V5.335A2.083 2.083 0 0 1 4.64 3.252h5.21l2.083 3.125h9.375A2.083 2.083 0 0 1 23.39 8.46z"/>
    </svg>
  );
};

export default CarpetaMasIcon;
